import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { lubricationSelectionAssistantPageQueryOptions } from "~/app/api/pageData/lubricationSelectionAssistantPageQuery";
import type { LubricationSelectionAssistantPageInitialData } from "~/app/api/pageData/lubricationSelectionAssistantPageTypes";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { LubricationSelectionAssistantPage } from "~/pages/LubricationSelectionAssistantPage/LubricationSelectionAssistantPage";

function LubricationSelectionAssistantRoute() {
  const result = useLoaderData({
    from: "/lubrication-selection-assistant",
  }) as PageInitialData<LubricationSelectionAssistantPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      <LubricationSelectionAssistantPage />
    </StorefrontShellFrame>
  );
}

export async function loadLubricationSelectionAssistantPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(lubricationSelectionAssistantPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const lubricationSelectionAssistantRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/lubrication-selection-assistant",
  loader: async ({ context }) => loadLubricationSelectionAssistantPageData(context),
  component: LubricationSelectionAssistantRoute,
});
